// x - independent dependent variable array(ordered)
// y - dependent variable array
// xarg - argument for function evaluation
// ideg - degree of polynomial(1 - linear, 2 - quadratic, etc)

// npts - number of points in arrays x, y
export function InterpolationAlgo(
  x: Array<number>,
  y: Array<number>,
  xarg: number,
  ideg: number,
  npts: number
): number {
  let xlagr;
  const n = Math.abs(npts) - 1; // to set the lentg index
  const n1 = ideg + 1;
  let l = 1;
  let max, min, factor, i, yest, j, term;
  let isExit = false;
  if (x[1] * 1.0 <= x[0] * 1.0) {
    l = 2;
  }
  if (l === 1) {
    // case2
    if (xarg <= x[0] * 1.0) {
      // case4
      xlagr = y[0] * 1.0;
      isExit = true;
    }
    // else if (xarg >= (x[n - 1] * 1.0)) {
    else if (xarg >= x[n] * 1.0) {
      // case5
      // xlagr = y[n - 1] * 1.0;
      xlagr = y[n] * 1.0;
      isExit = true;
    } else {
      // case6
    }
  } else {
    // case3
    if (xarg >= x[0] * 1.0) {
      // case4
      xlagr = y[0] * 1.0;
      isExit = true;
    }
    // else if (xarg <= (x[n - 1] * 1.0)) {
    else if (xarg <= x[n] * 1.0) {
      // case5
      // xlagr = y[n - 1] * 1.0;
      xlagr = y[n] * 1.0;
      isExit = true;
    } else {
      // case6
    }
  }
  // case6
  if (!isExit) {
    if (l === 1) {
      // case7
      for (max = n1; max <= n; max = max + 1) {
        if (xarg < x[max - 1] * 1.0) {
          break;
        }
      }
    } else {
      // case9
      for (max = n1; max <= n; max = max + 1) {
        if (xarg > x[max - 1] * 1.0) {
          break;
        }
      }
    }

    // case11
    min = max - ideg;
    factor = 1;
    for (i = min; i <= max; i = i + 1) {
      if (xarg !== x[i - 1] * 1.0) {
        // goto 12
        factor = factor * (xarg - x[i - 1] * 1.0);
      } else {
        xlagr = y[i - 1];
        isExit = true;
        break;
      }
      if (isExit) break;
    }
    //
    if (!isExit) {
      yest = 0;
      for (i = min; i <= max; i = i + 1) {
        term = (y[i - 1] * 1.0 * factor) / (xarg - x[i - 1] * 1.0);
        for (j = min; j <= max; j = j + 1) {
          if (i !== j) {
            term = term / (x[i - 1] * 1.0 - x[j - 1] * 1.0);
          }
        }
        yest = yest + term;
      }
      xlagr = yest;
    }
  }
  // lou change
  // return xlagr;
  return xlagr || 0;
}

// ?
export function pipe_in_situ_temperature(
  inlet_tempf: number,
  pipe_length: number,
  temperature_gradient: number
): number {
  return (inlet_tempf + inlet_tempf + pipe_length * temperature_gradient) / 2;
}

export function froude_transition_numbers(
  no_slip_liquid_fraction: number
): number[] {
  const HLns = no_slip_liquid_fraction;
  // HLns = 0.9190866335513113;
  const XL1 = 316 * Math.pow(HLns, 0.302) * 1.0;
  const XL2 = (0.0009252316 / Math.pow(HLns, 2.46842)) * 1.0;
  const XL3 = (0.1 / Math.pow(HLns, 1.45155)) * 1.0;
  const XL4 = (0.5 / Math.pow(HLns, 6.738)) * 1.0;
  let XDD = XL4 * 1;
  if (HLns < 0.4) {
    XDD = XL1;
  }
  return [XL1, XL2, XL3, XL4, XDD];
}

export function corrected_liquid_holdup_latest(
  flow_regime_BnB: string,
  froude_number_BnB: number,
  no_slip_liquid_fraction: number,
  inclination_angle_against_horizontal: number,
  liquid_velocity_no: number
): number {
  const HLns = no_slip_liquid_fraction;
  let E0 =
    (1.065 * Math.pow(HLns, 0.5824)) / Math.pow(froude_number_BnB, 0.0609);
  let CD = 1.0;
  let CE = 0.0;
  let CF = 0.0;
  let CG = 0.0;

  if (flow_regime_BnB === "Intermittent") {
    E0 = (0.845 * Math.pow(HLns, 0.5351)) / Math.pow(froude_number_BnB, 0.0173);
    CD = 2.96;
    CE = 0.305;
    CF = -0.4473;
    CG = 0.0978;
  } else if (flow_regime_BnB === "Segregated") {
    E0 = (0.98 * Math.pow(HLns, 0.4846)) / Math.pow(froude_number_BnB, 0.0868);
    CD = 0.011;
    CE = -3.768;
    CF = 3.539;
    CG = -1.614;
  }
  E0 = Math.max(HLns, E0);
  let HL = 0;
  const Radian = inclination_angle_against_horizontal; //* 3.14157 / 180;
  if (Math.abs(Radian) < 0.0001) {
    // (Horizontal Flow)
    HL = E0;
  } else if (Math.abs(Radian) < 0) {
    // (Downhill)
    CD = 4.7;
    CE = -0.3692;
    CF = 0.1244;
    CG = -0.5056;
  }

  // var liquid_velocity_no = 1.938 * liquid_superficial_velocity * Math.pow((liquid_density / surface_tension), 0.25);
  let C =
    (1 - HLns) *
    Math.log(
      CD *
        Math.pow(HLns, CE) *
        Math.pow(liquid_velocity_no, CF) *
        Math.pow(froude_number_BnB, CG)
    );
  // C = (1 - HLns) x loge[CD x HLns ^ CE * Liquid Velocity No.. ^ CF * Froude No.. ^ CG ]

  if (C < 0) {
    C = 0;
  }
  const XX = Math.sin(1.8 * Radian);

  const factor = 1 + C * (XX - 0.333 * Math.pow(XX, 3));
  // if (flow_regime_BnB == "Segregated") {
  //	factor = 1.8;
  // }
  HL = factor * E0;
  return Math.max(0, Math.min(1, HL));
}
